import { Component, OnInit, AfterViewInit, OnDestroy, HostListener, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CarriersService } from './carriers.service';
import { FavoriteDirective } from './../shared/directives/favorite.directive';
import { Contacts } from './../shared/models/contacts';
import { Carrier } from './../shared/models';
import { VesselResults } from '../shared/models/results';

@Component({
  selector: 'my-carriers',
  template: require('./carriers.component.html'),
  styles: [require('./carriers.component.scss')],
  providers: [CarriersService, FavoriteDirective],
})
export class CarriersComponent implements OnInit, OnDestroy, AfterViewInit {
  vessels: VesselResults = new VesselResults(null);

  carrier: Carrier = new Carrier(null);
  contacts: Contacts = new Contacts(null);
  country = { name: 'Select Country', id: '' };
  countries = [{ count: 0, country: this.country }];
  carrierId: number;
  sub: any;
  vesselsSub: any;
  carrierSub: any;
  contactsSub: any;
  pages: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  pageNumber: number = 1;
  paginationContext: string = '';
  offset: number = 0;
  limit: number = 20;

  sidebarActive = false;

  carrierNotice: HTMLElement;
  noticeLabel: HTMLElement;
  noticeData: HTMLElement;

  constructor(private service: CarriersService, private route: ActivatedRoute, private router: Router, private zone: NgZone) {
    // Do stuff
  }

  @HostListener('window:resize', ['$event.target'])
  onResize() {
    this.service.resizeSidebar();
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(this.setupPage.bind(this));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngAfterViewInit() {
    this.service.resizeSidebar();

    this.carrierNotice = document.getElementById('carrier-notice')
    this.noticeLabel = document.getElementById('notice-label')
    this.noticeData = document.getElementById('notice-data')
  }

  setupPage(params: { [key: string]: any }): void {
    this.carrierId = +params['id'];
    this.limit = +params['limit'] || 20;
    this.offset = +params['offset'] || 0;
    this.getVessels();
    this.getCarrier();
    this.getContacts();
    if (params['scroll'] != null && params['scroll'] === 'true') {
      window.scrollTo(0, 0);
    }
  }

  setupPagination() {
    this.pageNumber = Math.floor(this.offset / this.limit) + 1;
    let pageTotal = Math.ceil(this.vessels.total / this.limit);
    let newPages = [];

    if (this.pages === null) {
      this.pages = [];
    } else if (pageTotal <= 9) {
      let count = 0;
      for (let current = 1; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else if (this.pageNumber <= 5) {
      this.pages = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    } else if ((this.pageNumber > 5) && (this.pageNumber > pageTotal - 4)) {
      let count = 0;
      for (let current = pageTotal - 9; current <= pageTotal; current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    } else {
      let count = 0;
      for (let current = this.pageNumber - 5; (current < this.pageNumber + 4) && (current < pageTotal); current++) {
        newPages[count] = current;
        count = count + 1;
      }
      this.pages = newPages;
    }

    if (this.pageNumber === pageTotal) {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) + ' - ' + (this.vessels.total) + ' of ' + this.vessels.total;
    } else {
      this.paginationContext = (this.limit * (this.pageNumber - 1) + 1) +
        ' - ' + (this.limit * this.pageNumber) +
        ' of ' + this.vessels.total;
    }
  }

  toPage(page: number) {
    if (page == this.pageNumber){
      // dont call update
      return;
    }
    this.service.loaderOff = false;
    this.offset = (page - 1) * this.limit;
    this.update();
  }

  update() {
    this.router.navigate(['/carriers', this.carrierId, { limit: this.limit, offset: this.offset }]);
  }

  getVessels(retry = true) {
    this.service.loaderOff = false;
    let params = {
      limit: this.limit,
      offset: this.offset,
      carrier_id: this.carrierId
    };

    this.service.getVessels(params).then(this.formatVessels.bind(this)).catch(ex => {
      if (ex === 403 && retry) {
        this.getVessels(false);
      }
    });
  }

  formatVessels(results: VesselResults) {
    if (results !== null) {
      this.vessels = results;
    }
    this.setupPagination();
  }

  getCarrier(retry = true) {
    this.service.getCarrier(this.carrierId).then(this.formatCarrier.bind(this)).catch(ex => {
      if (ex === 403 && retry) {
        this.getCarrier(false);
      }
    });
  }

  formatCarrier(carrier) {
    if (carrier !== null) {
      this.carrier = carrier;

      var noticeType = carrier.notice.split(' ')[0]
      if (noticeType == 'Acquired' || noticeType == 'Merged'){
        this.carrierNotice.setAttribute('style', 'color: yellow;')
        this.noticeLabel.setAttribute('style', '')
        this.noticeData.setAttribute('style', '')
      } else if (carrier.notice.split(' ')[0] == 'Closed') {
        this.carrierNotice.setAttribute('style', 'color: red;')
        this.noticeLabel.setAttribute('style', '')
        this.noticeData.setAttribute('style', '')
      }
    }
  }

  getContacts(retry = true) {
    this.service.localContactsLoader = true;
    let params = {
      limit: 50,
      offset: 0,
      carrier_id: this.carrierId
    };

    if (this.service.app.country !== null) {
      params['country_id'] = this.service.app.country.id;
    }

    this.service.getLocalContacts(this.carrierId, params).then(this.formatLocalContacts.bind(this)).catch(ex => {
      if (ex === 403 && retry) {
        this.getContacts(false);
      }
    });
  }

  formatLocalContacts(localContacts: Contacts) {
    try {
      this.setContacts(localContacts);
    } catch (ex) {
      this.contacts = new Contacts(null);

      let country = { name: 'Select Country', id: '' };
      this.countries = [{ count: 0, country: country }];

      this.service.localContactsLoader = false;
    }
  }

  setContacts(localContacts: Contacts) {
    if (localContacts !== null && this.service.app.country.id !== '') {
      this.contacts = localContacts;
    }

    // Keep the default 'Select Country' in there
    let dataHasFavoritedCountry = false;
    for (let current = 0; current < this.contacts.countries.length; current++) {
      if (this.service.app.country.id === this.contacts.countries[current].country.id) {
        this.countries = this.contacts.countries;
        this.country = this.countries[current].country;
        dataHasFavoritedCountry = true;
      }
    }

    if (!dataHasFavoritedCountry) {
      this.countries = this.countries.concat(localContacts.countries);
    }
    this.service.localContactsLoader = false;
    this.service.resizeSidebar();
  }

  updateCountry() {
    if (this.country.id !== this.service.app.country.id && this.country.id !== '') {
      this.service.app.setCountry(this.country);

      this.getContacts();
    }
    this.service.resizeSidebar();
  }

  slideOutIn() {
    this.sidebarActive = !this.sidebarActive;
  }

  registerMessage() {
    this.service.app.showRegister();
  }

  expand(e) {
    e.showFull = !e.showFull;
    this.service.resizeSidebar();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/carriers/carriers.component.ts